import { render, staticRenderFns } from "./receipt-order-header.vue?vue&type=template&id=5d2d12da"
import script from "./receipt-order-header.vue?vue&type=script&lang=ts"
export * from "./receipt-order-header.vue?vue&type=script&lang=ts"
import style0 from "./receipt-order-header.vue?vue&type=style&index=0&id=5d2d12da&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports